module.exports = __webpack_public_path__ + "static/img/Gold3.116e9b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Gold3.svg
// module id = Um62
// module chunks = 35